import { render, staticRenderFns } from "./permisionsListing.vue?vue&type=template&id=79397438&scoped=true"
import script from "./permisionsListing.vue?vue&type=script&lang=js"
export * from "./permisionsListing.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79397438",
  null
  
)

export default component.exports